import fetch from 'unfetch';

const getGradeDist = async (barId) => {
	const url = `/api/bars/gradeDist`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({ barId: barId }),
	});

	if (res.ok) {
		return { status: 'success', data: await res.json() };
	} else {
		console.log(await res.json());
		return { status: 'error', data: await res.json() };
	}
};
export default getGradeDist;
